import React, { FC } from 'react'

interface FunnelProps {
  className?: string
}

const Funnel: FC<FunnelProps> = ({ className, children }) => {
  const styles = {
    both: {
      // height: '12ex',
    },
    left: {
      shapeOutside: 'polygon(0 0, 100% 100%, 0 100%)',
      clipPath: 'polygon(0 0, 100% 100%, 0 100%)',
    },
    right: {
      shapeOutside: 'polygon(100% 0, 100% 100%, 0 100%)',
      clipPath: 'polygon(100% 0, 100% 100%, 0 100%)',
    },
  }

  return (
    <div className={className}>
      <div
        className="float-left w-1/4 h-32"
        style={{ ...styles.both, ...styles.left }}
      ></div>
      <div
        className="float-right w-1/4 h-32"
        style={{ ...styles.both, ...styles.right }}
      ></div>
      <p>{children}</p>
    </div>
  )
}

export default Funnel
